import { ErrorHandling, RequirePermissionProps } from "@sagecentral/core-ui";
import { CustomCircularProgress } from "components/shared/layout";
import useTeamPermissions from "hooks/teams/useTeamPermissions";
import { Outlet } from "react-router-dom";

const RequireTeamPermission = (props: RequirePermissionProps) => {
    const permissions = useTeamPermissions() as any;
    if (permissions == null) return <CustomCircularProgress />;
    const authorized = (permissions[props.permission]) || false;
    return authorized ? <Outlet /> : <ErrorHandling error={{ message: "Unauthorized ", name: "Error", cause: 403 }} />;
};

export default RequireTeamPermission;